import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title flex flex-row w-full items-center leading-4 gap-2" }
const _hoisted_2 = { class: "gordita-500-14-m" }


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Props = {
  title: string;
  icon: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-block',
  props: {
    title: null,
    icon: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-block mx-6 p-4 min-w-[830px] max-w-[840px] bg-System/app_white flex flex-col gap-4 w-full rounded-lg border border-system-app-border" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(["uis uis-info-circle text-[24px] text-System/app_secondary", __props.icon])
        }, null, 2),
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})